import { render, staticRenderFns } from "./totalCustomer.vue?vue&type=template&id=fbac4674&scoped=true&"
import script from "./totalCustomer.vue?vue&type=script&lang=js&"
export * from "./totalCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbac4674",
  null
  
)

export default component.exports